function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.78 6.36a1 1 0 01.97 1.26l-1.79 6.68h3.03c.62 0 1.1.56.98 1.18l-.15.84c-.09.48-.5.82-.98.82H9.3c-.66 0-1.14-.64-.96-1.27l2.61-9.14c.06-.21.26-.36.48-.36h1.35v-.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.32 13.27a.748.748 0 01-.14-1.48l7.7-1.54a.75.75 0 11.29 1.47l-7.7 1.54c-.05.01-.1.01-.15.01z"
})));